(function ($) {
  'use strict';

  var NAMESPACE = 'click-off-close';

  $.fn.clickOffClose = function () {
    return this.each(function (index) {
      var $this = $(this),
        eventName = 'click.clickOffClose_' + index;

      function preventClick(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }

      function handleClick() {
        $this.fadeOut(250, function () {
          $this.remove();
          $(document).off(eventName);
        });
      }

      $this.on(eventName, preventClick);
      $(document).on(eventName, handleClick);
    });
  };

  $(function () {
    $('[data-plugin=' + NAMESPACE + ']').clickOffClose();
  });
})(jQuery);




// WEBPACK FOOTER //
// ./javascripts/components/legacy/plugins/jquery.click-off-close.js